import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import Ink from "react-ink";

import api from "../../config/api";
import "./style.css";
import StepTab from "./StepTab";
import BankDetails from "./BankDetails";
import PersonalDetail from "./PersonalDetail";
import Residence from "./Residence";
import Employer from "./Employer";
import NextOfKin from "./NextOfKin";
import Signature from "./Signature";
import Picture from "./Picture";
// import ConsentForm from "./ConsentForm";
import historyAction from "../../redux/history/action";
import onboardingAction from "../../redux/onboarding/action";
import rsaAction from "../../redux/rsaNINImplementation/action";
import PageHead from "../../component/pageHead/PageHead";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import CustomModel from "../../component/CustomModel/CustomModel";
import nextBlueIcon from "../../assets/icons/Conti_blue.png";
import prevBlueIcon from "../../assets/icons/back_blue.png";
import authAction from "../../redux/auth/action";
import constants from "../../config/constants";

class Onboarding extends Component {
  state = {
    step: 1,
    isLoading: false,
    pathname: null,
    isModelVisible: false,
    alertMessage: "",
  };

  componentDidMount() {
    const { history, setHistory } = this.props;

    this.setState({
      pathname: history.location.pathname,
    });

    this.validate();
    this.fetchCountries();

    setHistory(history);
  }

  fetchBaseURLandToken = async () => {
    try {
      const { setBaseURL, setRSANINVerificationToken } = this.props;
      const baseURLandToken = await api.getBaseURLandPublicToken();

      setBaseURL(baseURLandToken.data.result);
      setRSANINVerificationToken(baseURLandToken.data.format);
    } catch (e) {
      console.log(e);
    }
  };

  fetchCountries = async () => {
    try {
      const { saveCountries } = this.props;
      const response = await api.fetchCountries();

      saveCountries(response.data.result);
    } catch (e) {
      console.log("Error", e.message);
    }
  };

  validate = async () => {
    const { validateUser, getUser } = this.props;

    if (!validateUser.userName) {
      this.setState({ isLoading: true });

      try {
        const response = await api.getUsernameAndPasswordUBA(
          {
            userName: "test",
          },
          ""
        );

        const data = {
          userName: response.data.result.UserName,
          password: response.data.result.Password,
        };

        getUser(data);
      } catch (e) {
        console.log("Error", e.message);
      }
      this.setState({ isLoading: false });
    }
  };

  verifyNIN = async () => {
    try {
      if (isNaN(this.props.ssn)) {
        return this.props.setAlertMessage({
          type: "error",
          message: "NIN should be only number",
        });
      }
      if (this.props.ssn.length < 11 || this.props.ssn.length > 11) {
        return this.props.setAlertMessage({
          type: "error",
          message: "NIN should be 11 digit long",
        });
      }

      this.setState({
        isLoading: true,
      });

      await this.fetchBaseURLandToken();

      const { setIsFormHidden, baseURL, ninVerificationToken, ssn, setIsNINVerified } = this.props;

      const body = {
        nin: ssn,
      };
      const headers = {
        Authorization: `Bearer ${ninVerificationToken}`,
      };
      const response = await api.verifyNIN(body, headers, baseURL);

      await this.dataMappingInField(response.data);
      setIsNINVerified(true);
      setIsFormHidden(false);
    } catch (e) {
      const { setPersonalDetailField } = this.props;

      setPersonalDetailField({
        ssn: "",
      });

      this.setState({
        isModelVisible: true,
        alertMessage:
          "Record not found, Do you want to continue entering manually?",
      });
    }

    this.setState({
      isLoading: false,
    });
  };

  dataMappingInField = async (data) => {
    const {
      setPersonalDetailField,
      countries,
      setNextOfKinField,
      setResidenceField,
      setPictureField,
      setSignatureField,
      permanentAddressLocation,
      setEmployerField
    } = this.props;
    let nationalityCode;
    let stateCode;
    let LGACode;
    let permStateCode;
    let permLGACode;
    let permCountryCode;
    // let NOKStateCode;
    // let NOKLGACode;
    try {
      let dateOfBirth = await this.transformDateIntoValidDate(data.birthdate);

      setPersonalDetailField({
        surname: data.surname,
        firstname: data.firstname,
        middleName: data.maidenname,
        dateOfBirth: new Date(dateOfBirth),
        permCity: data.residence_Town,
        maidenName: data.maidenname,
        mobilePhone: data.telephoneno,
        confirmMobilePhone: data.telephoneno,
      });

      setResidenceField({
        permanentAddress: data.residence_AdressLine1,
        permZip: "234",
      });

      setEmployerField({
        employerZip: "234",
      })

      setNextOfKinField({
        nokName: data.nok_firstname,
        nokSurname: data.nok_surname,
        nokAddress1: data.nok_address1,
        nokAddress: Array.isArray(data.nok_address2) ? (data.nok_address2[0] || "") : "",
        // nokStatecode: NOKStateCode,
        // nokLga: NOKLGACode,
        nokZip: "234",
      });

      setPictureField("data:image/jpeg;base64," + data.picture);
      setSignatureField("data:image/jpeg;base64," + data.signature);

      await this.fetchCountries();

      // Finding Gender and Title Code
      let titleCode = data.title;
      titleCode = titleCode.replace(/\b[a-z]/g, (x) => x.toUpperCase());
      setPersonalDetailField({ title: titleCode });

      let genderCode = data.gender;
      genderCode = genderCode.replace(/\b[a-z]/g, (x) => x.toUpperCase());
      setPersonalDetailField({ gender: genderCode });

      // Finding Maritial Status
      let maritalStatusArray = constants.MARITAL_STATUS_CODES;
      let maritialStatusResponse = data.maritalstatus;
      maritialStatusResponse = maritialStatusResponse.replace(/\b[a-z]/g, (x) =>
        x.toUpperCase()
      );

      let maritalStatus = maritalStatusArray.find(
        //eslint-disable-next-line
        (item) => item.label == maritialStatusResponse
      );
      let maritalStatusCode = maritalStatus.value;
      setPersonalDetailField({ maritalStatusCode: maritalStatusCode });

      // For permenant country personal Detail tab
      if (data.birthcountry) {
        let permCountry = countries.find(
          //eslint-disable-next-line
          (item) => item.countryName == data.birthcountry.toUpperCase()
        );
        permCountryCode = permCountry.countryCode;
        setPersonalDetailField({ permCountry: permCountryCode });
      }

      // For Nationality (Personal Details Tab)
      if (data.birthcountry) {
        let nationalityCountry = countries.find(
          //eslint-disable-next-line
          (item) => item.countryName == data.birthcountry.toUpperCase()
        );
        nationalityCode = nationalityCountry.countryCode;
      }
      setPersonalDetailField({ nationalityCode: nationalityCode });

      // For State Of Origin and LGA (Personal Details Tab)
      if (data.self_origin_state && data.birthcountry) {
        let states = await this.fetchStates(nationalityCode);
        let stateOfOrigin = states.find(
          //eslint-disable-next-line
          (item) => item.stateName == data.self_origin_state.toUpperCase()
        );
        stateCode = stateOfOrigin.stateCode;
        setPersonalDetailField({ stateOfOrigin: stateCode });

        if (data.self_origin_lga) {
          let LGA = await this.fetchLGA(stateCode);
          let allLGA = LGA.find(
            //eslint-disable-next-line
            (item) => item.lgaName == data.self_origin_lga.toUpperCase()
          );
          LGACode = allLGA.lgaCode;
          setPersonalDetailField({ lgaCode: LGACode });
        }
      }

      // For Perm State Of Origin and LGA (Personal Details Tab)
      if (data.residence_state && permanentAddressLocation) {
        let permAddressLocation;

        if (permanentAddressLocation === "N") {
          permAddressLocation = "NG";
        } else {
          permAddressLocation = permanentAddressLocation
        }

        let states = await this.fetchPermStates(permAddressLocation);
        console.log(states)
        let stateOfOrigin = states.find(
          //eslint-disable-next-line
          (item) => item.stateName == data.residence_state.toUpperCase()
        );
        console.log(stateOfOrigin)
        permStateCode = stateOfOrigin.stateCode;
        setPersonalDetailField({ permState: permStateCode });

        if (data.residence_lga) {
          let LGA = await this.fetchPermLGA(permStateCode);
          let allLGA = LGA.find(
            //eslint-disable-next-line
            (item) => item.lgaName == data.residence_lga.toUpperCase()
          );
          permLGACode = allLGA.lgaCode;
          setPersonalDetailField({ permLga: permLGACode });
        }
      }

      // console.log(permanentAddressLocation)
      // // For State Of Origin and LGA (NOK Tab)
      // if (data.nok_state) {  // needed country validation
      //   let states = await this.fetchNOKStates("NG") // needed country code
      //   let stateOfOrigin = states.find(item => item.stateName == data.nok_state.toUpperCase())
      //   NOKStateCode = stateOfOrigin.stateCode

      //   if (data.nok_lga) {
      //     let LGA = await this.fetchNOKLGA(stateCode)
      //     let allLGA = LGA.find(item => item.lgaName == data.self_origin_lga.toUpperCase())
      //     NOKLGACode = allLGA.lgaCode
      //   }
      // }
    } catch (e) {
      console.log(e);
    }
  };

  transformDateIntoValidDate = (rawDate) => {
    const parts = rawDate.split("-");
    const monthNum = Number(parts[1]);
    return parts[0] + "-" + constants.MONTHS[monthNum] + "-" + parts[2];
  };

  fetchStates = async (nationalityCode) => {
    try {
      const { token, setAllStates } = this.props;

      // this.setState({ allStates: [] });

      if (!nationalityCode) {
        nationalityCode = this.props.nationalityCode;
      }

      const state = await api.fetchState(
        { countryCode: nationalityCode },
        token
      );

      setAllStates({ allStatesArray: state.data.result });
      return state.data.result;
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchLGA = async (stateOfOrigin) => {
    try {
      const { token, setAllLGA } = this.props;

      if (!stateOfOrigin) {
        stateOfOrigin = this.props.stateOfOrigin;
      }

      const LGA = await api.fetchLGA({ stateCode: stateOfOrigin }, token);

      setAllLGA({ allLGAArray: LGA.data.result });
      return LGA.data.result;
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchPermStates = async (nationalityCode) => {
    try {
      const { token, setAllPermStates } = this.props;

      // this.setState({ allStates: [] });

      if (!nationalityCode) {
        nationalityCode = this.props.nationalityCode;
      }

      const state = await api.fetchState(
        { countryCode: nationalityCode },
        token
      );

      setAllPermStates({ allStatesArray: state.data.result });
      return state.data.result;
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchPermLGA = async (stateOfOrigin) => {
    try {
      const { token, setAllPermLGA } = this.props;

      if (!stateOfOrigin) {
        stateOfOrigin = this.props.stateOfOrigin;
      }

      const LGA = await api.fetchLGA({ stateCode: stateOfOrigin }, token);

      setAllPermLGA({ allPermLGA: LGA.data.result });
      return LGA.data.result;
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchNOKStates = async (nationalityCode) => {
    try {
      const { token, setAllNOKStates } = this.props;

      this.setState({ allStates: [] });

      if (!nationalityCode) {
        nationalityCode = this.props.nationalityCode;
      }

      const state = await api.fetchState(
        { countryCode: nationalityCode },
        token
      );

      setAllNOKStates({ allStatesArray: state.data.result });
      return state.data.result;
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchNOKLGA = async (stateOfOrigin) => {
    try {
      const { token, setAllNOKLGA } = this.props;

      if (!stateOfOrigin) {
        stateOfOrigin = this.props.stateOfOrigin;
      }

      const LGA = await api.fetchLGA({ stateCode: stateOfOrigin }, token);

      setAllNOKLGA({ allLGAArray: LGA.data.result });
      return LGA.data.result;
    } catch (e) {
      console.log("E =>", e);
    }
  };
  mannualyAddData = () => {
    const { setIsFormHidden } = this.props;

    setIsFormHidden(false);
    this.setState({ isModelVisible: false });
  };

  scrollToTop = () => {
    const target = document.querySelector(".card-container .flex1");
    var maxScroll = target.scrollHeight;

    var scrollInt = setInterval(() => {
      if (target.scrollTop !== 0) {
        target.scrollTop -= maxScroll / 100;
      } else {
        clearInterval(scrollInt);
      }
    }, 10);
  };

  decideTab = () => {
    const { step } = this.state;

    switch (step) {
      case 1:
        return (
          <PersonalDetail customRef={(el) => (this.personalDetail = el)} />
        );
      case 2:
        return <Residence customRef={(el) => (this.residence = el)} />;
      case 3:
        return <Employer customRef={(el) => (this.employer = el)} />;
      case 4:
        return <NextOfKin customRef={(el) => (this.nextOfKin = el)} />;
      case 5:
        return <BankDetails customRef={(el) => (this.bankDetails = el)} />;
      case 6:
        return <Signature customRef={(el) => (this.signature = el)} />;
      case 7:
        return <Picture customRef={(el) => (this.picture = el)} />;
      // case 8:
      //   return <ConsentForm customRef={el => (this.consentForm = el)} />;
      default:
        return;
    }
  };

  decideBottomBtnContainerClasses = () => {
    const { step } = this.state;

    let baseClass = "d-flex";
    if (step === 1) {
      baseClass = baseClass + " justify-content-end";
    } else if (step === 8) {
      baseClass = baseClass + " justify-content-start";
    } else {
      baseClass = baseClass + " justify-content-between";
    }

    return baseClass;
  };

  onStepChange = (step) => {
    const { step: currentStep } = this.state;
    const { setAlertMessage } = this.props;
    let isError = true;

    if (currentStep < step) {
      if (currentStep === 1) isError = this.personalDetail.validate();
      if (currentStep === 2) isError = this.residence.validate();
      if (currentStep === 3) isError = this.employer.validate();
      if (currentStep === 4) isError = this.nextOfKin.validate();
      if (currentStep === 5) isError = this.bankDetails.validate();
      if (currentStep === 6) isError = this.signature.validate();
      if (currentStep === 7) isError = this.picture.validate();
    }

    if (!isError)
      return setAlertMessage({
        type: "error",
        message: "Please fill all required fields",
      });

    this.setState({ step }, () => this.scrollToTop());
  };

  render() {
    const { isFormHidden } = this.props;
    const { step, isLoading } = this.state;

    return (
      <Container className="pt-2">
        <div className="d-flex justify-content-between">
          <img
            style={{ height: "80px" }}
            src={require("../../assets/icons/app-icon.png")}
            alt="PPL LOGO"
          />
        </div>
        <PageHead
          leftText="RSA PIN REGISTRATION"
          rightText="COMPLETE ALL FIELDS"
          containerStyles={{ width: "100%" }}
        />
        <Row className="my-2 justify-content-center">
          <Col className="p-1 pl-sm-0" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 1)}
              text="Personal Detail"
              active={step === 1}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 2)}
              text="Residence"
              active={step === 2}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 3)}
              text="Nature of Business"
              active={step === 3}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 4)}
              text="Next of Kin"
              active={step === 4}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 5)}
              text="Bank Details"
              active={step === 5}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 6)}
              text="Signature"
              active={step === 6}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 7)}
              text="Picture"
              active={step === 7}
            />
          </Col>
          {/* <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 8)}
              text="Consent Form"
              active={step === 8}
            />
          </Col> */}
        </Row>
        {this.decideTab()}
        <div className={this.decideBottomBtnContainerClasses()}>
          <div
            hidden={!isFormHidden}
            className="continue-btn-container my-3"
            onClick={() => this.verifyNIN()}
          >
            <p className="flex1 text-center mr-2">Verify NIN</p>
            <img alt="nextbutton" src={nextBlueIcon} width="20px" />
            <Ink />
          </div>
          {step !== 1 && (
            <div
              className="continue-btn-container my-3"
              onClick={this.onStepChange.bind(this, step - 1)}
            >
              <img alt="prevbutton" src={prevBlueIcon} width="20px" />
              <p className="text-center flex1 ml-2">Back</p>
              <Ink />
            </div>
          )}
          {step !== 7 && (
            <div
              hidden={isFormHidden}
              className="continue-btn-container my-3"
              onClick={this.onStepChange.bind(this, step + 1)}
            >
              <p className="flex1 text-center mr-2">Continue</p>
              <img alt="nextbutton" src={nextBlueIcon} width="20px" />
              <Ink />
            </div>
          )}
        </div>
        <CustomModel
          alertMessage={this.state.alertMessage}
          onClickSuccess={() => this.mannualyAddData()}
          onClickReject={() => this.setState({ isModelVisible: false })}
          hidden={this.state.isModelVisible ? false : true}
        />
        {isLoading && <CustomLoader />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  validateUser: state.onboarding.user,
  formRefno: state.rsaNINImplementation.personalDetail.formRefno,
  isFormHidden: state.rsaNINImplementation.isFormHidden,
  baseURL: state.rsaNINImplementation.baseURL,
  ninVerificationToken: state.rsaNINImplementation.ninVerificationToken,
  ...state.rsaNINImplementation.personalDetail,
  countries: state.onboarding.countries,
  token: state.rsaNINImplementation.token,
  ...state.rsaNINImplementation.nextOfKin,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  getUser: onboardingAction.getUser,
  saveCountries: onboardingAction.saveCountries,
  setAlertMessage: authAction.setAlertMessage,
  setPersonalDetailField: rsaAction.setPersonalDetailField,
  resetForm: rsaAction.resetRSAForm,
  setBaseURL: rsaAction.setBaseURL,
  setIsFormHidden: rsaAction.setIsFormHidden,
  setRSANINVerificationToken: rsaAction.setRSANINVerificationToken,
  setAllStates: rsaAction.setAllStates,
  setAllLGA: rsaAction.setAllLGA,
  setAllNOKStates: rsaAction.setAllNOKStates,
  setAllNOKLGA: rsaAction.setAllNOKLGA,
  setNextOfKinField: rsaAction.setNextOfKinField,
  setResidenceField: rsaAction.setResidenceField,
  setPictureField: rsaAction.setPictureField,
  setSignatureField: rsaAction.setSignatureField,
  setIsNINVerified: rsaAction.setIsNINVerified,
  setAllPermStates: rsaAction.setAllPermStates,
  setAllPermLGA: rsaAction.setAllPermLGA,
  setEmployerField: rsaAction.setEmployerField
};

export default connect(mapStateToProps, mapDispatchToProps)(Onboarding);
